module.exports = __webpack_public_path__ + "img/drivers-trustsight.589d19d8.jpg";